export default {
  'component.contractandsettlement.title': 'Kontrakt & oppgjør',
  'component.contractandsettlement.salesinformation': 'Salgsinformasjon',
  'component.contractandsettlement.settlementinformation': 'Oppgjørsinformasjon',
  'component.contractandsettlement.yourfeedback': 'Din tilbakemelding',
  'component.contractandsettlement.financing': 'Finansiering',
  'component.contractandsettlement.movingguide': 'Flytteguiden',
  'component.contractandsettlement.takeover': 'Overtagelse',
};
